export default __webpack_public_path__ + "static/media/mi.35001390.png";